module.exports = __webpack_public_path__ + "static/satellite-a6d6fb50497388b2157943d5dafe6013.png";